import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { hideWarningDialog } from "../../../redux/actions/warning";
import useWarningMessage from "../hooks/useWarningMessage";

const WarningDialog = () => {

    useWarningMessage();
    const dispatch = useDispatch();
    
    const { open, message } = useSelector((state) => state.warning);

    const handleClose = (_, reason) => {
        if (reason === "backdropClick") {
            return;
        }

        dispatch(hideWarningDialog());
    };


    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle
                sx={{
                    backgroundColor: "#0f8b73",
                    color: "#ffffff",
                    textAlign: "center",
                    fontWeight: 700,
                    py: 1.25,
                }}
            >
                Advertencia
            </DialogTitle>
            <DialogContent sx={{ px: 4, py: 3, textAlign: "justify" }}>
                <DialogContentText sx={{ color: "#303030", fontWeight: 600 }}>
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
                <Button onClick={handleClose} color="primary" variant="contained">
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default WarningDialog;